<template>
    <span>
            <template   v-if="tableRowButtons" v-for="v in tableRowButtons" >
                        <el-button v-if="v.type=='ButtonCheckShow' && (v.CheckShow? v.CheckShow(data):true)" :type="v.buttonType" :size='"mini"' :style="{marginRight: '5px'}" @click="v.forClick(data,this)" >{{v.nickName}}</el-button>
                        <el-button v-else-if="v.type=='Button'  && (v.CheckShow? v.CheckShow(data):true)" :type="v.buttonType" :size='"mini"' :style="{marginRight: '5px'}" @click="v.forClick(data,this)" >{{v.nickName}}</el-button>
                        <el-button v-else-if="v.type=='text'  && (v.CheckShow? v.CheckShow(data):true)" :type="v.buttonType" :size='"mini"' :style="{marginRight: '5px',color:'red'}"  @click="v.forClick(data,this)" >{{v.nickName}}</el-button>

                        <el-badge v-else-if="v.type=='badgeButton'  && (v.CheckShow? v.CheckShow(data,v):true)" :value="data._____badgeValue" class="item">
                            <el-button  :type="v.buttonType" :size='"mini"' :style="{marginRight: '5px'}" @click="v.forClick(data,this)" >{{v.nickName}}</el-button>
                        </el-badge>


                        
                        <el-popover   trigger="manual"  v-else-if="v.type=='ConfirmButton'  && (v.CheckShow? v.CheckShow(data):true)"  placement="top" width="200"  v-model="IsConfirm[v.PID]">
                        <div v-if="IsConfirm && IsConfirm[v.PID]">
                        <p >{{v.confirmTitle? v.confirmTitle :gets('$是否确定？')}}</p>
                        <p v-if="v.confirmContent">{{v.confirmContent}}</p>
                        <div style="text-align: right; margin: 0">
                            <el-button size="mini" type="text" @click="hide(v.PID)">{{gets('$取消')}}</el-button>
                            <el-button type="primary" size="mini" @click="confirm(v)">{{gets('$确定')}}</el-button>
                        </div>
                         </div>
                        <el-button :style="{marginRight: '5px'}" slot="reference" v-if="!v.hide"  :size='"mini"' :type="v.buttonType"  @click="show(v.PID)" >{{v.nickName}}</el-button>
                        </el-popover>
            </template>
    </span>
 </template>

     
<script>
    var c = 0;
    var isType = false;
    import gets from "@/model/language.js";
    export default {
        props: ["tableRowButtons", "data","index"],
        data() {
            return {
                IsConfirm:{}
            };
        },
        created() {
          
            for (var i of this.tableRowButtons) {
                if (i.type == "ConfirmButton") {
                    c++;
                    if (!i.PID) {
                        i.PID = "c" + c;
                    }
                    this.IsConfirm[i.PID] = false
                
                }


            }
              
        },
        computed: {},
        methods: {
            gets: gets,
            show(id){
                this.IsConfirm[id] =true
                this.$forceUpdate()
               
            },
              hide(id){
                this.IsConfirm[id] =false
                this.$forceUpdate()
               
            },
            confirm(v,data,index){
                                 this.IsConfirm[v.PID] =false
                                   this.$forceUpdate()
                                 if(v.forClick){
                                     v.forClick(this.data,this.index)
                                  }
                            }
        },
        watch: {
            tableRowButtons() {
                // console.log(this.data.__$IsConfirm)
                // console.log('this.data.__$IsConfirm')
                for (var i of this.tableRowButtons) {
                    if (i.type == "ConfirmButton") {
                        c++;
                        if (!i.PID) {
                            i.PID = "c" + c;
                        }
                          this.IsConfirm[i.PID] = false
                     
                    }
                    
                }
            }
        }
    };
</script>





// WEBPACK FOOTER //
// table_TableRowButtons.vue?352176ab